/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Scene_Description_Import_FailedInputs */

const en_scene_description_import_failed = /** @type {(inputs: Scene_Description_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to import shot descriptions: ${i?.error}`)
};

const fr_scene_description_import_failed = /** @type {(inputs: Scene_Description_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec de l'importation des descriptions de plans : ${i?.error}`)
};

const de_scene_description_import_failed = /** @type {(inputs: Scene_Description_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler beim Importieren der Shot-Beschreibungen: ${i?.error}`)
};

const it_scene_description_import_failed = /** @type {(inputs: Scene_Description_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile importare le descrizioni delle inquadrature: ${i?.error}`)
};

const ru_scene_description_import_failed = /** @type {(inputs: Scene_Description_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось импортировать описания кадров: ${i?.error}`)
};

const es_scene_description_import_failed = /** @type {(inputs: Scene_Description_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al importar las descripciones de las tomas: ${i?.error}`)
};

const zh_cn2_scene_description_import_failed = /** @type {(inputs: Scene_Description_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`导入镜头描述失败：${i?.error}`)
};

const ja_scene_description_import_failed = /** @type {(inputs: Scene_Description_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ショットの説明のインポートに失敗しました: ${i?.error}`)
};

const hi_scene_description_import_failed = /** @type {(inputs: Scene_Description_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`शॉट विवरण आयात करने में विफल: ${i?.error}`)
};

const pt_pt2_scene_description_import_failed = /** @type {(inputs: Scene_Description_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao importar as descrições das fotos: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to import shot descriptions: {error}" |
*
* @param {Scene_Description_Import_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_description_import_failed = /** @type {((inputs: Scene_Description_Import_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Description_Import_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_scene_description_import_failed(inputs)
	if (locale === "de") return de_scene_description_import_failed(inputs)
	if (locale === "it") return it_scene_description_import_failed(inputs)
	if (locale === "ru") return ru_scene_description_import_failed(inputs)
	if (locale === "es") return es_scene_description_import_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_scene_description_import_failed(inputs)
	if (locale === "ja") return ja_scene_description_import_failed(inputs)
	if (locale === "hi") return hi_scene_description_import_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_scene_description_import_failed(inputs)
	return en_scene_description_import_failed(inputs)
});